















import { defineComponent, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import PasswordForm from '@/renderer/components/user/components/passwordForm.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import successIcon from '@/renderer/assets/images/Icon/svg/successPay.svg';
import tips from '@/renderer/scripts/utils/tips';
import passwordHandler from '@/renderer/components/user/compositions/passwordHandler';
import user from '@/renderer/scripts/utils/user';
export default defineComponent({
  components: {
    ChevronLeftIcon,
    BaseIcon,
    PasswordForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    email: String,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const saved = ref(false);
    const { updatePassword } = passwordHandler();
    const methods = {
      async savePassword(params: CoFile.EditUserPassword) {
        const res = await updatePassword({
          originalAccountPassword: params.oldPassword as string,
          accountPassword: params.newPassword,
        });
        if (res) {
          saved.value = true;
          tips.success(i18n_t('修改成功，请重新登录'));
          setTimeout(() => {
            user.signOut();
          }, 1000);
        }
      },
    };
    return {
      successIcon,
      innerShow,
      saved,
      ...methods,
    };
  },
});
